import React from 'react';
import CancellationsTable from './table/CancellationsTable';
import { CancellationsUIProvider } from './context/CancellationsUIContext';

export default function Cancellations () {
    return (
        <CancellationsUIProvider>
            <CancellationsTable/>
        </CancellationsUIProvider>
    );
}
